import { OrderDirection } from '../../Datatable/OrderDirection';
import { QueryItem } from '../../Tonnage/models/TonnageQueryModel';
export default interface MarketInfoQueryModel {
    vesselNames: QueryItem[],
    owners: QueryItem[],
    charterers: QueryItem[],
    marketInfoType: MarketInfoType,
    cargoTypes: QueryItem[],
    loadPortAreas: QueryItem[],
    disportAreas: QueryItem[],
    sizeMin: number,
    sizeMax: number,
    updatedDateFrom: number,
    orderBy: string,
    orderDirection: OrderDirection,
}

export enum MarketInfoType {
    TCT = "TCT",
    Voy = "Voy",
    All = "All",
    Period = "Period",
    TC = "TC",
    COA = "COA",
}